module.exports = __webpack_public_path__ + "img/path-1.d2eefdb6.svg";